import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-segunda-opinion-confirmada',
  standalone: true,
  imports: [CommonModule, MatIconModule, MatButtonModule],
  templateUrl: './segunda-opinion-confirmada.component.html',
  styleUrls: ['./segunda-opinion-confirmada.component.scss']
})
export class SegundaOpinionConfirmadaComponent {
  isDetailsExpanded = true;
  telefono = '5555555555';
  expediente = '#SO-2025-001';

  toggleDetails() {
    this.isDetailsExpanded = !this.isDetailsExpanded;
  }

  makeCall() {
    window.open(`tel:${this.telefono}`, '_self');
  }

  openWhatsApp() {
    const message = `Hola, necesito información sobre mi Segunda Opinión. Expediente: ${this.expediente}`;
    const whatsappUrl = `https://wa.me/${this.telefono}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  }
}